
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  import { Playground } from 'docz'
import Resource from '@/components/Resource'
import ResourceModel from '@/models/Resource'

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}>
<MDXTag name="h2" components={components} props={{"id":"resource-tracker"}}>{`Resource Tracker`}</MDXTag>
<Playground __position={0} __code={'<Resource\n  model={ResourceModel.create({\n    current: 5,\n    maximum: 10,\n    name: \'New Resource\',\n  })}\n/>'} __scope={{props: this ? this.props : props,Resource,ResourceModel}}>
  <Resource model={ResourceModel.create({
    current: 5,
    maximum: 10,
    name: 'New Resource',
  })} />
</Playground>
           </MDXTag>
  }
}
  